import { CALL_API, Schemas } from '../../common/middleware/api';

export const CHECK_EMAIL_REQUEST = 'CHECK_EMAIL_REQUEST';
export const CHECK_EMAIL_SUCCESS = 'CHECK_EMAIL_SUCCESS';
export const CHECK_EMAIL_FAILURE = 'CHECK_EMAIL_FAILURE';

export const AUTHENTICATION_RECORDS_REQUEST = 'AUTHENTICATION_RECORDS_REQUEST';
export const AUTHENTICATION_RECORDS_SUCCESS = 'AUTHENTICATION_RECORDS_SUCCESS';
export const AUTHENTICATION_RECORDS_FAILURE = 'AUTHENTICATION_RECORDS_FAILURE';

export const checkEmail = (options, onSuccessEvent, formName) => ({
	[CALL_API]: {
		types: [CHECK_EMAIL_REQUEST, CHECK_EMAIL_SUCCESS, CHECK_EMAIL_FAILURE],
		endpoint: 'api/emailInfrastructureChecker',
		method: 'POST',
		request: options,
		onSuccessEvent,
		form: formName
	}
});

export const getAuthenticationRecords = () => ({
	[CALL_API]: {
		types: [AUTHENTICATION_RECORDS_REQUEST, AUTHENTICATION_RECORDS_SUCCESS, AUTHENTICATION_RECORDS_FAILURE],
		endpoint: 'api/emailInfrastructureChecker',
		schema: Schemas.AUTHENTICATION_RECORDS
	}
});